<template>
  <div>
    <PageTitle>
      Лицензионное соглашение
      условия использования системы МедТочка для
      получения консультаций<br />
      (Публичная оферта)
    </PageTitle>
    <div class="mb-6 d-flex justify-space-between text-body-2 text-ui-kit-text-secondary">
      <div>г. Краснодар</div>
      <div>05 сентября 2025 г.</div>
    </div>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Настоящая публичная оферта адресована физическим лицам (далее –
      Клиентам), намеревающимся воспользоваться Консультацией, оказываемой Клиникой.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Настоящий документ является официальным и публичным предложением
      общества с ограниченной ответственностью «{{ COMPANY_NAME_SHORT }}» (далее – Администратор)
      заключить договор, предмет и условия которого указаны ниже.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      1. Термины и определения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      В рамках настоящего соглашения используются следующие термины и
      определения:
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.1. <span class="font-weight-semi-bold">«Администратор»</span> – {{ COMPANY_NAME }}, обладатель исключительного
      права на программу для ЭВМ «Личный кабинет пациента MedTochka», являющуюся
      результатом интеллектуальной деятельности.<br />
      Реквизиты Администратора:<br />
      Общество с ограниченной ответственностью «{{ COMPANY_NAME_SHORT }}», ОГРН
      1122311003760, ИНН 2311144947, адрес: 350015, г. Краснодар, ул. им. Буденного, д.
      182, оф. 87; email: <NuxtLink to="mailto:help@medrocket.ru">help@medrocket.ru</NuxtLink>,
      телефон 8 (495) 374-93-56. Режим работы: 08:00-17:00 (по Московскому времени).
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.2. <span class="font-weight-semi-bold">«Система МедТочка» («МедТочка»)</span> – программа для ЭВМ «Личный
      кабинет пациента MedTochka», принадлежащая Администратору, являющаяся его
      собственной разработкой (свидетельство о государственной регистрации программы
      для ЭВМ «Личный кабинет пациента MedTochka» &#8470;2021613412 от 09 марта 2021 г.),
      объединенная общим целевым назначением и размещенная в сети Интернет по адресу
      <NuxtLink to="https://medtochka.ru/">https://medtochka.ru/</NuxtLink> и включающая в себя мобильное приложение «МедТочка».
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.3. <span class="font-weight-semi-bold">«Клиент»</span> – любое дееспособное физическое лицо, достигшее
      18-летнего возраста, акцептовавшее настоящую публичную оферту, и имеющее намерение
      воспользоваться Системой МедТочка для получения Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.4. <span class="font-weight-semi-bold">«Клиника»</span> – организация, оказывающая Клиенту Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.5. <span class="font-weight-semi-bold">«Консультация»</span> – Телемедицинская консультация или Информационная
      консультация, оказываемая Клиникой Клиенту.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.6. <span class="font-weight-semi-bold">«Телемедицинская консультация»</span> – дистанционная медицинская
      услуга, оказываемая Клиникой Клиенту, осуществляемая посредством Системы
      МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.7. <span class="font-weight-semi-bold">«Информационная консультация»</span> – дистанционная немедицинская
      услуга, носящая информационный характер, оказываемая Клиникой Клиенту и
      осуществляемая посредством Системы МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.8. <span class="font-weight-semi-bold">«Заключение»</span> – документ, составленный в электронном виде
      специалистом Клиники по итогам оказания Консультации, направленный Клиенту
      посредством МедТочки.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.9. <span class="font-weight-semi-bold">«Цена консультации»</span> – полная стоимость Консультации,
      установленная Клиникой и подлежащая оплате Клиентом.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.10. <span class="font-weight-semi-bold">«Договор»</span> – настоящий договор и приложения к нему.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.11. <span class="font-weight-semi-bold">«Система ПроДокторов»</span> – программа для ЭВМ «Информационная
      система ProDoctorov» (свидетельство об официальной регистрации программы для
      ЭВМ «Информационная система ProDoctorov» &#8470; 2018619813 от 13.08.2018 г.),
      размещенная в сети Интернет по адресу <NuxtLink to="https://prodoctorov.ru/">https://prodoctorov.ru/</NuxtLink>. Система ПроДокторов
      предназначена для предоставления Клиентам информации о врачах и клиниках,
      отзывах пациентов, визуализации рейтингов, наличии свободных временных
      интервалов у врачей, а также организации записи на прием в медицинские учреждения.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1.1.12. <span class="font-weight-semi-bold">«Акцепт»</span> – полное и безоговорочное принятие настоящей оферты
      Администратора, путем осуществления действий, указанных в разделе 4 настоящей
      оферты.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      2. Общие положения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.1. Администратор предоставляет Клиенту право использования (лицензию)
      Системы МедТочка в целях получения Клиентом Консультации специалиста Клиники.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.1.1. Условия предоставления права использования Системы МедТочка
      Клиенту:
    </p>
    <ul class="mb-4 public-offer__ul public-offer__ul_dashed pl-6">
      <li class="text-body-2 text-ui-kit-text">
        вид лицензии - неисключительная;
      </li>
      <li class="text-body-2 text-ui-kit-text">срок действия - на весь срок действия Договора;</li>
      <li class="text-body-2 text-ui-kit-text">территория - Российская Федерация;</li>
      <li class="text-body-2 text-ui-kit-text">лицензия предоставляется на безвозмездной основе;</li>
      <li class="text-body-2 text-ui-kit-text">
        Клиент получает право использования основного функционала
        программного обеспечения без права копирования, распространения, модификации и
        дизассемблирования.
      </li>
    </ul>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.2. Права и обязанности при оказании Консультации возникают
      непосредственно между Клиникой и Клиентом. Администратор не несет
      ответственность перед Клиентом или любыми третьими лицами за любой прямой,
      косвенный, случайный либо иной моральный или материальный ущерб, нанесенный
      Клиенту или любым третьим лицам вследствие полученной Консультации. Все
      претензии к объему и качеству оказанной Консультации Клиент предъявляет
      непосредственно к Клинике.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.3. Исходя из существа функциональных возможностей Системы МедТочка,
      Администратор от имени, по поручению и за счет Клиники совершает действия,
      связанные с получением платежей от Клиентов за проведенные Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.4. Администратор не осуществляет медицинскую деятельность.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2.5. Клиент не предоставляет Администратору отчет об использовании Системы
      МедТочка, в соответствии с п. 1 ст. 1237 ГК РФ.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      3. Порядок использования системы МедТочка
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.1. Система МедТочка представляет собой облачный сервис, позволяющий
      устанавливать сеанс видеосвязи между Клиентом и специалистом (врачом) Клиники,
      получать/отправлять текстовые сообщения, получать доступ к медицинским
      документам Клиента, загруженным им в МедТочку, в целях проведения Консультации,
      а также предоставлять Клиенту Заключение, оформленное по результатам
      Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.2. В рамках Консультации осуществляется запись сеанса видеосвязи.
      Срок хранения видеозаписи составляет 30 (тридцать) календарных дней.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.3. Сеанс видеосвязи защищается Администратором сквозным шифрованием,
      что позволяет обеспечить должный уровень защиты передаваемой информации во
      время Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.4. Запись на Консультацию и заключение договора на осуществление
      Консультации производится посредством Системы ПроДокторов.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.5. В Системе МедТочка возможно проведение двух типов Консультаций:
      Телемедицинские консультации и Информационные консультации. Клиент обязан
      ознакомиться с договором на проведение Консультации перед его заключением.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.6. После формирования записи на Консультацию Клиент обязан внести
      предоплату за Консультацию в течение 20 (двадцати) минут. В случае неоплаты
      Консультации в указанное время запись на Консультацию аннулируется и считается
      отмененной.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.7. После успешной оплаты Клиенту в Системе МедТочка предоставляется чат
      со специалистом Клиники. Доступ к чату со специалистом Клиники Клиент получает
      не ранее чем за 5 (пять) минут до начала Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.8. Доступ к чату со специалистом Клиники закрывается автоматически через 2
      (два) часа после начала времени Консультации или может быть закрыт принудительно
      Клиентом или специалистом Клиники путем отдачи команды в Системе МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.9. В процессе Консультации Клиент и специалист Клиники имеют
      возможность обмениваться текстовыми сообщениями, а также устанавливать сеанс
      видеосвязи. Выбор способа проведения Консультации производится Клиентом и
      Клиникой по обоюдному согласию.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.10. Перенос времени и/или даты Консультации недоступен. В случае если
      Клиенту необходимо перенести запись на Консультацию на другое время и/или дату,
      Клиент должен отменить запись на Консультацию в Системе МедТочка и осуществить
      запись повторно.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.11. После проведения Консультации Клиника направляет Клиенту Заключение
      посредством Системы МедТочка. Клиент имеет право получить доступ к Заключению в
      личном кабинете Системы МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3.12. Клиент ознакомлен и согласен с тем, что Телемедицинские консультации
      осуществляются в целях профилактики, сбора, анализа жалоб Клиента и данных
      анамнеза, оценки эффективности лечебно-диагностических мероприятий,
      медицинского наблюдения за состоянием, а также принятия решения о необходимости
      проведения очного приема.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      4. Акцепт
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4.1. Акцептом Клиента является согласие с настоящей офертой, которое
      выражается в совершении следующих действий:
    </p>
    <p
      class="pl-8 text-body-2 mb-4 text-ui-kit-text public-offer-alphabetic-list"
    >
      <span class="public-offer-alphabetic-list__marker">а)</span>запись Клиента на Консультацию;<br />
      <span class="public-offer-alphabetic-list__marker">б)</span>осуществление онлайн оплаты Клиентом стоимости
      Консультации не позднее
      20 (двадцати) минут с момента осуществления им записи на Консультацию. Если по
      истечении 20 (двадцати) минут оплата Консультации не была произведена, запись на
      Консультацию отменяется автоматически Системой МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4.2. Настоящая оферта считается заключенной в момент совершения Клиентом
      Акцепта, что означает согласие Клиента со всеми положениями настоящей оферты.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4.3. Путем Акцепта настоящей оферты Клиент дает свое согласие
      Администратору на обработку своих персональных данных (далее — Согласие),
      включающее следующую информацию о Клиенте: фамилия, имя, отчество (на русском
      языке), дата рождения, контактный номер телефона, адрес электронной почты, а также
      сведения о фактах обращения и/или намерении обратиться к врачу и/или в
      медицинское учреждение, сведения о состоянии здоровья, необходимые для получения
      Консультаций, изображение гражданина (видеозапись) посредством сбора,
      записи, систематизации, накопления, хранения,
      уточнения, извлечения, использования, осуществляемую с использованием средств
      автоматизации, в том числе в информационно-телекоммуникационных сетях, или без
      использования таких средств, передачи своих персональных данных Клинике, в целях
      организации направления ему специальных предложений, информации о новых
      услугах и рекламных акциях, обработки его запросов и обращений, а также в целях
      организации и проведения Консультаций согласно настоящей оферте.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4.4. Исполнение Администратором обязательств перед Клиентом
      подтверждается предоставлением Клиенту доступа к чату со специалистом Клиники в
      Системе МедТочка.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4.5. Полномочия Администратора ограничиваются предоставлением Клиенту
      права использования Системы МедТочка, а также принятием и зачислением денежных
      средств Клиента за Консультацию на лицевой счет Клиники. Ответственность за отказ
      Клиники от исполнения обязательств по предоставлению услуг Администратор не
      несет.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      5. Оплата консультации
    </p>

    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.1. Клиент обязан ознакомиться со всеми условиями настоящей оферты, а
      также с условиями договора между Клиникой и Клиентом на проведение
      Консультации перед осуществлением записи на Консультацию. В случае, если Клиенту
      не понятны какие-либо условия оферты, в том числе условия отказа, возврата, Клиент
      вправе уточнить необходимую для него информацию у Администратора или
      отказаться от акцепта настоящей оферты.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.2. При осуществлении записи на Консультацию Клиент заполняет все поля,
      указанные как «обязательные» для заполнения. Ответственность за точность,
      правильность и законность информации, предоставленной при оформлении записи на
      Консультацию, несет Клиент.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.3. В момент осуществления записи на Консультацию Клиенту
      предоставляется информация о Цене Консультации для утверждения. Оплата
      Консультации Клиентом является юридическим подтверждением (согласием) Клиента
      с Ценой Консультации и условиями получения указанной Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.4. Клиент осуществляет 100% предоплату Консультации посредством
      банковского перевода денежных средств на расчетный счет Администратора.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.5. Оплата Консультации осуществляется в безналичном порядке следующими
      способами:
    </p>
    <ul class="mb-4 pl-6">
      <li class="text-body-2 mb-4 text-ui-kit-text">
        Банковская карта: Visa, MasterCard, МИР.
      </li>
    </ul>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Списание денежных средств производится в рублях Российской Федерации.
      При оплате возможно дополнительное списание платежной системой денежных
      средств за конвертацию валют.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Получателем платежа является Администратор, который действует от имени и в
      интересах Клиники.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Все расходы, связанные с оплатой Консультации несет Клиент.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      После оплаты Консультации на адрес электронной почты, указанный при её
      оплате, отправляется кассовый чек.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.6. В случае отмены оплаченной Консультации до момента её начала
      предоплаченные денежные средства возвращаются Клиенту на банковский счет, с
      которого была произведена оплата Консультации, в течение 10 (десяти) рабочих дней с
      момента отмены Консультации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.7. Отмена записи на Консультацию менее чем за 60 (шестьдесят) минут до её
      начала возможна только путем обращения к Администратору в порядке, указанном в п.
      7.5.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5.8. В случае если Клиника в установленное время Консультации, а также в
      течение 15 (пятнадцати) минут после начала времени Консультации, не приступила к
      проведению Консультации, что подтверждается отсутствием текстовых сообщений в
      чате и/или попыток установления сеанса связи с Клиентом, то Клиент вправе
      обратиться в Клинику с запросом о возврате денежных средств.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      6. Ограниченная гарантия администратора
    </p>

    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.1. Администратор предоставляет Клиенту возможность пользоваться
      программным обеспечением Системы МедТочка «как оно есть», без каких-либо
      дополнительных гарантий со стороны Администратора.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2. Администратор не несет ответственности за неисполнение или
      ненадлежащее исполнение обязательств по Договору, а также возможный ущерб,
      возникший в результате:
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.1. неправомерных действий пользователей сети Интернет, направленных на
      нарушение информационной безопасности или нормального функционирования
      Системы МедТочка;
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.2. сбоев в работе программного обеспечения, вызванных ошибками в коде
      или посторонними фрагментами кода в Системе МедТочка;
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.3. отсутствия (невозможности установления, прекращения и прочее)
      Интернет-соединения между сервером Администратора и сервером Клиента;
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.4. проведения государственными и муниципальными органами, а также
      иными организациями мероприятий в рамках Системы оперативно-розыскных
      мероприятий (СОРМ);
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.5. установления государственного регулирования (или регулирования
      иными организациями) хозяйственной деятельности коммерческих организаций в сети
      Интернет и/или установления указанными субъектами разовых ограничений,
      затрудняющих или делающих невозможным исполнение Договора;
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.2.6. других случаев, связанных с действиями (бездействием) пользователей
      Интернета и/или других субъектов, направленными на ухудшение общей ситуации с
      использованием сети Интернет и/или компьютерного оборудования, существовавшей
      на момент заключения Договора.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6.3. Клиент самостоятельно обеспечивает техническую возможность
      использование Системы МедТочка для получения Консультации. Администратор не
      несет ответственности за несовместимость устройства Клиента (смартфона, планшета,
      компьютера и т.п.) и/или его программного обеспечения с Системой МедТочка.
    </p>

    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      7. Заключительные положения
    </p>

    <p class="text-body-2 mb-4 text-ui-kit-text">
      7.1. Настоящая оферта является публичной офертой в соответствии с
      Гражданским кодексом Российской Федерации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7.2. Администратор вправе в любое время в одностороннем порядке вносить
      изменения в текст настоящей оферты, прекращать оферту, размещать новую оферту. В
      связи с чем Клиент обязуется регулярно отслеживать изменения условий оферты при
      совершении записи на Консультацию.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7.3. Все споры лиц, заключивших настоящую оферту, разрешаются путем
      переговоров. В случае, если Стороны не придут к решению возникших между ними
      споров в ходе переговоров, такие споры разрешаются судом в соответствии с
      законодательством Российской Федерации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7.4. Для урегулирования возможных споров, Клиент вправе направить претензию
      посредством электронных сообщений, писем на бумажном носителе по почтовому адресу Администратора.
      Администратор, в свою очередь, обязуется рассматривать полученные претензии
      и давать на них ответы в установленные законом сроки.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7.5. В случае возникновения вопросов со стороны Клиента, он вправе
      обратиться к Администратору по электронной почте, телефону службы поддержки,
      или иным доступным способом, указанным на сайте <NuxtLink to="https://prodoctorov.ru/">https://prodoctorov.ru/</NuxtLink> в разделе
      «Контакты». При этом Администратор обязан дать ответ таким же способом, которым
      к нему поступил соответствующий вопрос.
    </p>
    <p class="text-body-2 text-ui-kit-text mb-0">
      7.6. Клиент подтверждает свое согласие с тем, что факт отдачи команды через
      Систему МедТочка с использованием его учетной информации означает
      конклюдентные действия Клиента по активации или деактивации определенного
      функционала Системы МедТочка, равно как и иных действий, ассоциируемых с
      Клиентом (все действия, произведенные с использованием учетной информации
      Клиента, являются действиями самого Клиента, что является бесспорным
      доказательством волеизъявления Клиента на выполнение этих действий).
    </p>
  </div>
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import { onlyRuPage } from '~/core/i18n'
import { COMPANY_NAME, COMPANY_NAME_SHORT } from '~/constants/contacts'

definePageMeta({
  layout: 'sidebar',
  middleware: onlyRuPage,
})

useHead({
  link: generatePageMetaLinks({
    noAlternates: true,
  }),
})
</script>

<style lang="scss">
.public-offer {
  &-alphabetic-list {
    position: relative;

    &__marker {
      position: absolute;
      left: 16px;
    }
  }

  &__ul {
    &_dashed {
      list-style-type: "-";
    }

    li {
      padding-left: 8px;
    }
  }
}
</style>
